export type StaffPermission = 'manage_students' | 'manage_staff' | 'view_payments';
export type StaffRole = 'admin' | 'teacher' | 'accountant';

export const rolePermissions: Record<StaffRole, Record<StaffPermission, boolean>> = {
  admin: {
    manage_students: true,
    manage_staff: true,
    view_payments: true,
  },
  teacher: {
    manage_students: true,
    manage_staff: false,
    view_payments: false,
  },
  accountant: {
    manage_students: false,
    manage_staff: false,
    view_payments: true,
  },
};

export const permissionLabels: Record<StaffPermission, string> = {
  manage_students: 'Manage Students',
  manage_staff: 'Manage Staff',
  view_payments: 'View Payments',
};

export const getPermissionsForRole = (role: string) => {
  return rolePermissions[role as StaffRole] ?? {
    manage_students: false,
    manage_staff: false,
    view_payments: false,
  };
};

export const hasPermission = (role: string, permission: StaffPermission) => {
  return Boolean(getPermissionsForRole(role)[permission]);
};
